import { SidebarAction } from "@/actions/components/sidebar";
import { CLIENT_ONBOARDING_STEPS } from "@/constants/common/onboarding-steps";
import router from "next/router";

export function sendToCurrentOnboardingSteps(...args)
{
    var completed_step_index    =   args[0];
    var job_id                  =   args[1] 
    var options                 =   args[2][0]; 
    var queryClient             =   args[3]; 
    var setPageName             =   args[4]; 
    var sidebarKey              =   args[5];     
    var SidebarOption           =   options[sidebarKey].subSidebar_options;
    var keys_array              =   Object.keys(SidebarOption);
    var setPageName             =   args[4]; 

    if( url_step_is_greater_than_current_step(completed_step_index) )
    {
        redirect_to_current_step(completed_step_index, job_id, keys_array, SidebarOption)
    }
}


function redirect_to_current_step(completed_step_index, job_id, keys_array, SidebarOption)
{
    var key     =   null;
    var link    =   null;
    var index   =   completed_step_index;

    
    for(let value of keys_array)
    {
        if(SidebarOption[value].step == index-1)
        {   
            key  =  value;
            link = replace_id(SidebarOption[value].link, job_id);
            router.push(link)
            // nextPage(key, setPageName, queryClient, link);
            break;
        }
    }
}

function replace_id(url, id)
{
    var urlArray = url.split('/');
    for( let element of urlArray)
    {
        if(element.startsWith('$'))
        {
            var index  = urlArray.indexOf(element);
            urlArray[index] = id;
            break
        }
    }
    return urlArray.join('/');
}

export function addParamsToUrl(queryParams, router)
{
    router.push({
                    pathname :  router.asPath.split('?')[0],
                    query    :  queryParams,
                    shallow  :  true
                })
}

export async function asyncAddParamsToUrl(queryParams, router)
{
    await router.push({
                        pathname :  router.asPath.split('?')[0],
                        query    :  queryParams,
                        shallow  :  true
                    })
}


function url_step_is_greater_than_current_step(completed_step_index)
{
    var url_step_index    =   current_url_index();
    return url_step_index > completed_step_index + 1 ;
}

function current_url_index()
{
    var url_arr         =   window.location.pathname.split('/');
    var next_val        =   url_arr[url_arr.length -1];

    return CLIENT_ONBOARDING_STEPS[next_val];
}